/* eslint-disable no-useless-computed-key */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { NavLink } from "react-router-dom";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import gstActions from "../../../../Admin/Setup/redux/actions";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { ListTable } from "./ListTable";
import productSetupActions from "../../../../Product/Setup/redux/actions";
import { CustomForm } from "./CustomForm";
import crudActions from "../../../../CRUD/redux/actions";
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import managementActions from "../../../Management/redux/actions";
import adminActions from "../../../../Admin/Home/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const PointOfSale = (props) => {
    const { createDetails, createError, editDetails, editError, createData } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { getTeamList, parameterDetails } = useSelector(state => state.homeReducer);
    const { mopDetails } = useSelector(state => state.adminSetupReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { locationDetails } = useSelector(state => state.productSetupReducer);
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [iconAnimation, setIconAnimation] = useState(false);
    const { history } = props;
    const limit = 25;
    const [skip, setSkip] = useState(0);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const dispatch = useDispatch();

    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const [addMore, setAddMore] = useState(false);
    const [view, setView] = useState(false);
    const [error, setError] = useState({});
    const [form, setForm] = useState({});
    const [visible, setVisible] = useState(false);
    const [posId, setPosId] = useState('');
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    //const [importVisible, setImportVisible] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [name, setName] = useState('');
    const [posCreate, setPosCreate] = useState(false);
    const [posUserCreate, setPosUserCreate] = useState(false);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Point of Sale (POS)', history, 'Sales')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const loadTasks = () => {
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
                order: 'id desc'
            }
        });
        locationApi();
        dispatch({
            type: managementActions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: adminActions.TEAM_DETAILS_START, url: 'team', skip: 0, filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    }

    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const handleAdd = () => {
        setView(false);
        handleOpen();
    }

    const handleOpen = () => {
        setPosId('');
        setVisible(true);
        let a = locationDetails?.filter(el => el.default);
        let locationId = '';
        if (a?.length > 0) {
            locationId = a[0]?.id;
        } else {
            locationId = locationDetails[0]?.id;
        }
        setForm({
            locationId: locationId
        });
        setError({});
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["or"]: [] };

        if (search !== '') {
            filter['or'].push({ posNumber: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ deviceIdentifier: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'point-of-sales',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }


    const handleClose = () => {
        setVisible(false);
        setForm({});
        setError({});
    }

    const handleAddMore = (e) => {
        createPos(e);
        setAddMore(true);
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            })
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            })
        }
    }

    const customObject = (details, id) => {
        let a = details && details?.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const createPos = (e) => {
        e.preventDefault();
        let emptyPosNumber = emptyValidation('POS Number', form?.posNumber);
        let emptyDefaultCustomer = emptyValidation('Default Customer', form?.defaultCustomerId);
        let emptyDefaultUser = emptyValidation('Default User', form?.defaultUserId);
        let emptyDefaultMop = emptyValidation('Default User', form?.defaultMopId);
        let emptyReceiptTemplate = emptyValidation('Receipt Template', form?.receiptTemplate);
        let emptyLocation = emptyValidation('Location', form?.locationId);
        //let emptyDeviceIdentifier = emptyValidation('Device Identifier', form?.deviceIdentifier);

        if (emptyPosNumber.isValid &&
            emptyDefaultCustomer.isValid &&
            emptyReceiptTemplate.isValid &&
            emptyDefaultMop.isValid && emptyLocation.isValid) {
            let customer = customObject(customerDetails, form?.defaultCustomerId);
            if (customer) {
                form.defaultCustomerName = customer.name;
            }
            
            let mop = customObject(mopDetails, form?.defaultMopId);
            if (mop) {
                form.defaultMopName = mop.method;
            }
            let user = customObject(getTeamList, form?.defaultUserId);
            if (user) {
                form.defaultUserName = user.name;
            }
            form.description = form?.description || '';
            form.deviceIdentifier = '  ';
            delete form.id; delete form.business; delete form.defaultCustomer; delete form.location; delete form.defaultUser; delete form.defaultMop;

            dispatch({
                type: posId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'point-of-sales',
                id: posId,
                title: 'Point of Sales',
                details: form
            });
            setPosCreate(true);
        } else {
            setError({
                'posNumber': emptyPosNumber.errors,
                'defaultCustomerId': emptyDefaultCustomer.errors,
                'defaultUserId': emptyDefaultUser.errors,
                'receiptTemplate': emptyReceiptTemplate.errors,
                'defaultMopId': emptyDefaultMop.errors,
                'locationId': emptyLocation.errors,
                // 'deviceIdentifier': emptyDeviceIdentifier.errors
            });
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (posCreate) {
                dispatchFilter(sortBy, sortOrder);
                handleClose();
                toast.dismiss();
                toast(createDetails);
                if (addMore) {
                    setAddMore(false);
                    setTimeout(function () {
                        setVisible(true);
                    }, 500)
                }

                let details = {
                    'posId': createData?.id,
                    'userId': createData?.defaultUserId,
                    'isDefaultUser': true
                };
                dispatch({
                    type: crudActions.CREATE_DETAILS_START,
                    url: 'point-of-sale-users',
                    id: posId,
                    title: 'Point of Sales',
                    details: details
                });
                setPosCreate(false);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            setError({
                ...error,
                "posNumber": text
            })
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            if (posCreate) {
                dispatchFilter(sortBy, sortOrder);
                handleClose();
                toast.dismiss();
                toast(editDetails);
                setPosCreate(false);
            }
            if (posUserCreate) {
                dispatchFilter(sortBy, sortOrder);
                setPosUserCreate(false);
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            setError({
                ...error,
                "posNumber": text
            })
        }
    }, [editDetails, editError]);

    const onView = (data, view) => {
        setView(view);
        handleOpen();
        setPosId(data.id);
        setForm({ ...data });
        dispatch({
            type: actions.POS_SETUP_USERS_START,
            url: 'point-of-sale-users',
            filter: {
                where: { "posId": data.id },
            }
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setPosId(data.id);
        setName(data.posNumber);
    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} cls={'newImg'} img={SalesIcon} title={'Sales'} links={[{ 'label': 'Sales', 'link': '/sales' },
            { 'label': 'Point of Sale (POS)', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Point of Sale Set up'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Point of Sale (POS)', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                id={idNamingConversion('Search', 'pointOfSale', 'TextField')}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={classes.textAlignRight}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkCRUDPermission('Point of Sale (POS)', 'create', 'Sales') &&
                                            <NavLink
                                                to={`#`}
                                                id={idNamingConversion('New POS', 'pointOfSale', 'Link')}
                                                onClick={() => handleAdd()}
                                                className={clsx(classes.customLink)}>
                                                <Image
                                                    src={AddIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>New POS</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Point of Sale (POS)', 'Action', 'Filter') &&
                                            <></>
                                        }
                                    </Space>
                                </Col>
                            </Row>
                            <ListTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                sortOrder={sortOrder}
                                onView={(data) => onView(data, true)}
                                onEdit={(data) => onView(data, false)}
                                onDelete={(data) => onDelete(data)}
                                sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <CustomForm
                visible={visible}
                form={form}
                customerDetails={customerDetails}
                posId={posId}
                error={error}
                view={view}
                classes={classes}
                handleClose={() => handleClose()}
                clsx={clsx}
                customObject={(details, id) => customObject(details, id)}
                changeHandler={(e, name = '') => changeHandler(e, name)}
                createPos={(e) => createPos(e)}
                teamDetails={getTeamList}
                handleAddMore={(e) => handleAddMore(e)}
                mopDetails={mopDetails || []}
                handleView={(value) => setView(value)}
                getTeamList={getTeamList}
                locationDetails={locationDetails}
                dispatch={dispatch}
                parameterDetails={parameterDetails}
                handleDefaultUser={(id) => {
                    setPosUserCreate(true);
                    setForm({
                        ...form,
                        'defaultUserId': id
                    })
                }}
            />
            {
                deleteModal && <DeleteModal onClose={(v) => setDeleteModal(v)} id={posId}
                    loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={name} url={'point-of-sales'}
                    title={'Point of Sale Set up'} visible={deleteModal} />
            }
        </React.Fragment>
    )
}

export default PointOfSale